<template>
  <div id="app" >
    <router-view />
    <div  v-show="loading" class="app-loading">
     <van-loading color="#98c312"  type="spinner" size="36px" vertical>加载中...</van-loading>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'App',
  data() {
    return {
      renderStatus:false
    }
  },

    computed:{
    ...mapState({
          loading: (state) => state.app.loading,
    })
  }

}
</script>

<style lang="less">
/*#app {*/
/*  font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
/*  -webkit-font-smoothing: antialiased;*/
/*  -moz-osx-font-smoothing: grayscale;*/
/*  text-align: center;*/
/*  color: #2c3e50;*/
/*  margin-top: 60px;*/
/*}*/
.app-loading{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  vertical-align: middle;
  background: #fff;
  opacity: 0.8;
  z-index: 9999;
  padding-top: 35vh;
  .van-loading__text{
  color: #98c312;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue